import React from 'react'
import Image from 'next/image'

import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import Header from 'components/Header'
import { HOST, TAIL } from 'constants/image'

const Usage = () => {
  const {
    t,
    i18n: { language: lang },
  } = useTranslation()

  return (
    <>
      <Header title={t('usage')} />
      <Image
        src={
          lang === 'es'
            ? `${HOST}/asset/common/usage/commerce/usage_en_2211.jpg${TAIL}`
            : `${HOST}/asset/common/usage/commerce/usage_${lang}_2211.jpg${TAIL}`
        }
        alt=""
        width={0}
        height={0}
        sizes="100%"
        style={{
          width: '100%',
          height: '100%',
        }}
      />
    </>
  )
}

export default Usage

export const getServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, 'common')),
    },
  }
}
